/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "./pixReceiptInfo.css";
import { parseISO, isValid, format } from "date-fns";
import { copyToClipboard, formatAmount } from "../../../../services/helpers";
import { ModalPaymentInstructions } from "../ModalPaymentInstructions";
import { ModalCopyPix } from "../ModalCopyPix";
import ptBR from "date-fns/esm/locale/pt-BR/index.js";

import PixIcon from "../../../../images/logo-pix.png";
import { RiArrowRightSFill } from "react-icons/ri";
import NumberFormat from "react-number-format";
import { socket } from "../../../../services/socket";

export function PixReceiptInfo({ rechargeMsisdn, pixData, amount }) {
  const pixDataLocal = JSON.parse(localStorage.getItem("@pix-data")) || [];
  const accountDetails = JSON.parse(localStorage.getItem("clientInfo")) || [];

  const [isCopiedBilletCode, setIsCopiedBilletCode] = useState(false);
  const [statusPayment, setPaymentStatus] = useState("Pendente");
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openPixKeyModal, setOpenPixKeyModal] = useState(false);

  useEffect(() => {
    let initial = true;
    if (rechargeMsisdn !== "") {
      socket.emit("pix-server-app", {
        txid: pixData.txid,
        value: pixData.value || amount,
        msisdn: accountDetails.number,
        rechargeMsisdn: rechargeMsisdn,
        pixKey: pixData.pixKey,
        qrcode: pixData.qrcode || pixData.qrCode,
        pixExpirationDate: pixData.pixExpirationDate,
      });

      console.log("emmited pix-receipt-info");
      return () => {
        initial = false;
      };
    }
  }, [rechargeMsisdn]);

  socket.on("pix-client", (data) => {
    if (data.status === "P00") {
      setPaymentStatus("Pago");
      socket.emit("pix-server-app-response", {
        msisdn: accountDetails.number,
        txid: pixData.txid,
        rechargeMsisdn: pixDataLocal.rechargeMsisdn || pixData.rechargeMsisdn,
      });
      // socket.disconnect();
      localStorage.removeItem("@pix-data");
      // socket.disconnect();
    }
    console.log("pix recepit info", data);
    // socket.disconnect();
    localStorage.setItem("@pix-data", JSON.stringify(data));
  });

  const dateParsed =
    pixData.pixExpirationDate &&
    pixData.pixExpirationDate !== "" &&
    parseISO(pixData.pixExpirationDate);

  const formattedDate = format(
    isValid(dateParsed) ? dateParsed : new Date(),
    "'Dia' dd 'de' MMMM', às ' HH:mm",
    { locale: ptBR }
  );

  const handleCopyBilletCode = (e, billetLine) => {
    copyToClipboard(billetLine);
    setIsCopiedBilletCode(!isCopiedBilletCode);
  };

  const handleOpenModalPayment = () => setOpenPaymentModal(!openPaymentModal);
  const handleOpenPixKeyModal = () => {
    setOpenPixKeyModal(true);
    setTimeout(() => {
      setOpenPixKeyModal(false);
    }, 1500);
  };

  return (
    <section>
      {openPaymentModal && (
        <ModalPaymentInstructions
          handleOpenModalPayment={handleOpenModalPayment}
        />
      )}
      {openPixKeyModal && (
        <ModalCopyPix handleOpenPixKeyModal={handleOpenPixKeyModal} />
      )}
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="receipt-info">
              <div className="receipt-info-header">
                <img
                  width="160"
                  src={require("../../../../images/pix-banco-central.svg")}
                  alt=""
                />
                <h3>
                  <span>Recarga aguardando pagamento</span>
                </h3>
                <p className="text-center">
                  Copie o código para pagar via PIX em qualquer aplicativo
                  habilitado:
                </p>
              </div>
              <div className="receipt-info-body">
                <div className="receipt-info-code">
                  <img
                    className="img-responsive"
                    width="160"
                    src={`data:image/png;base64,${
                      pixData.qrCode || pixData.qrcode
                    }`}
                    alt=""
                  />
                </div>
                <div className="receipt-copy-button">
                  <button
                    type="button"
                    onClick={(e) => {
                      handleCopyBilletCode(e, pixData.pixKey);
                      handleOpenPixKeyModal();
                    }}
                    //   onClick={() => handleEmitt()}
                    className="btn btn-pix"
                  >
                    <img
                      src={require("../../../../images/pix-white.svg")}
                      width="30"
                      alt=""
                    />
                    <span>Copiar código Pix</span>
                  </button>

                  <div className="mt-5 text-center">
                    <h5> Pague até: {`${formattedDate}`} </h5>
                  </div>
                </div>
              </div>
              <div className="my-5">
                <p>
                  Plano -{" "}
                  {formatAmount(amount || pixData.value || pixData.amount)}
                  {/* <a href="#" title="see-plans"  className="see-plan-details"onClick={(e) => {
                                                e.preventDefault();
                                               handleOpenModalPlan() 
                                            }}> ver detalhes do plano</a> */}
                </p>
              </div>
              <hr />
              <div className="my-5">
                <p>
                  <div style={{ marginBottom: "0.8rem" }}>
                    Número <br />
                  </div>

                  <span className="gray-1" style={{ marginTop: "12px" }}>
                    <NumberFormat
                      type="text"
                      value={
                        rechargeMsisdn.length > 11
                          ? rechargeMsisdn.substring(2)
                          : rechargeMsisdn
                      }
                      displayType={"text"}
                      format="(##) #####-####"
                    />
                  </span>
                </p>
              </div>
              <hr className="" />
              <div className="my-5 space-between">
                <div>Total -</div>
                <div className="green">
                  {formatAmount(amount || pixData.value || pixData.amount)}
                </div>
              </div>
              <hr />
              <div className="my-5 space-between">
                <div>Status -</div>
                {statusPayment === "Pago" && (
                  <div className="green">{statusPayment}</div>
                )}
                {statusPayment === "Pendente" && (
                  <div className="danger">{statusPayment}</div>
                )}
              </div>
              <hr />
              <div
                className="receipt-info-footer"
                onClick={() => handleOpenModalPayment()}
              >
                <div>
                  <img src={PixIcon} alt="" width={"20"} />
                </div>
                Instruções de como usar pix para pagar:
                <div style={{ marginLeft: "auto" }}>
                  <RiArrowRightSFill />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
